/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedinteraccountingemail33Inputs */

const en__field_inheritedinteraccountingemail33 = /** @type {(inputs: _Field_Inheritedinteraccountingemail33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`internal accounting e-mail 3 (inherited)`)
};

const de__field_inheritedinteraccountingemail33 = /** @type {(inputs: _Field_Inheritedinteraccountingemail33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne Accounting E-Mail 3 (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "internal accounting e-mail 3 (inherited)" |
*
* @param {_Field_Inheritedinteraccountingemail33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedinteraccountingemail33 = /** @type {((inputs?: _Field_Inheritedinteraccountingemail33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedinteraccountingemail33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedinteraccountingemail33(inputs)
	return de__field_inheritedinteraccountingemail33(inputs)
});
export { _field_inheritedinteraccountingemail33 as "_field_inheritedInterAccountingEmail3" }